import { render } from "./WatchlistPage.vue?vue&type=template&id=65d3f297"
import script from "./WatchlistPage.vue?vue&type=script&lang=js"
export * from "./WatchlistPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__